<template>
  <div class="fp">
    <div class="fp-cabecera">
      <div>
        <h1 class="fp-titulo">Facturacion de planes</h1>
        <p class="fp-subtitulo">Factura electronica SRI de los planes de suscripcion y configuracion del emisor.</p>
      </div>
    </div>

    <!-- Tabs -->
    <div class="fp-tabs">
      <button :class="['fp-tab', { 'fp-tab--activo': tab === 'planes' }]" @click="tab = 'planes'">
        <i class="bi bi-receipt"></i> Planes a facturar
      </button>
      <button :class="['fp-tab', { 'fp-tab--activo': tab === 'facturas' }]" @click="irFacturas">
        <i class="bi bi-collection"></i> Facturas emitidas
      </button>
      <button :class="['fp-tab', { 'fp-tab--activo': tab === 'emisor' }]" @click="irEmisor">
        <i class="bi bi-building-gear"></i> Emisor
      </button>
    </div>

    <div v-if="error" class="alerta alerta-error"><i class="bi bi-exclamation-triangle-fill"></i> {{ error }}</div>

    <!-- ════════════ TAB PLANES ════════════ -->
    <div v-show="tab === 'planes'">
      <div class="filtros-fila">
        <input v-model="filtros.busqueda" type="text" class="campo-busqueda" placeholder="Buscar empresa o RUC..." />
        <select v-model="filtros.estado" class="campo-select">
          <option value="">Todas las suscripciones</option>
          <option value="activa">Activa</option>
          <option value="en_gracia">En gracia</option>
          <option value="vencida">Vencida</option>
          <option value="cancelada">Cancelada</option>
        </select>
        <select v-model="filtros.facturacion" class="campo-select">
          <option value="">Toda facturacion</option>
          <option value="pendiente">Sin facturar</option>
          <option value="facturada">Facturada</option>
        </select>
        <button class="btn btn--secundario btn--xs" :disabled="cargando" @click="cargar">
          <i class="bi" :class="cargando ? 'bi-arrow-clockwise spin' : 'bi-arrow-clockwise'"></i> Refrescar
        </button>
        <button class="btn btn--primario btn--xs" :disabled="loteEnCurso" @click="facturarTodos">
          <i class="bi" :class="loteEnCurso ? 'bi-arrow-clockwise spin' : 'bi-lightning-charge'"></i>
          {{ loteEnCurso ? 'Generando...' : 'Facturar todos' }}
        </button>
      </div>

      <div v-if="loteResumen" class="alerta alerta-info">
        <i class="bi bi-info-circle"></i> {{ loteResumen }}
      </div>

      <div class="tabla-contenedor">
        <div v-if="cargando" class="texto-vacio"><i class="bi bi-arrow-clockwise spin"></i> Cargando...</div>
        <table v-else class="tabla">
          <thead>
            <tr>
              <th>Empresa / RUC</th><th>Plan</th><th>Ciclo a facturar</th>
              <th class="text-end">Monto (sin IVA)</th><th>Vigencia</th>
              <th>Suscripcion</th><th>Factura</th><th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!filtradas.length"><td colspan="8" class="texto-vacio">Sin resultados</td></tr>
            <tr v-for="s in filtradas" :key="s.suscripcion_id">
              <td>
                <div class="tabla__empresa">{{ s.empresa_razon_social }}</div>
                <div class="tabla__ruc">{{ s.empresa_ruc }}</div>
              </td>
              <td><span class="plan-badge">{{ s.plan_nombre }}</span><div class="tabla__ruc">{{ s.plan_codigo }}</div></td>
              <td>
                <select v-model="ciclos[s.suscripcion_id]" class="campo-select campo-select--mini">
                  <option value="mensual">Mensual (${{ money(s.precio_mensual) }})</option>
                  <option value="trimestral">Trimestral (${{ money(s.precio_trimestral) }})</option>
                  <option value="anual">Anual (${{ money(s.precio_anual) }})</option>
                </select>
              </td>
              <td class="text-end tabla__monto">${{ money(montoCiclo(s)) }}</td>
              <td>
                <span :class="venceCss(s.dias_restantes)">
                  {{ fmtDate(s.fecha_fin) }}<small v-if="s.dias_restantes != null"> ({{ s.dias_restantes }}d)</small>
                </span>
              </td>
              <td><span class="estado-chip" :class="estadoCss(s.suscripcion_estado)">{{ s.suscripcion_estado }}</span></td>
              <td>
                <span v-if="s.factura_id" class="estado-chip" :class="facturaCss(s.factura_estado)">{{ facturaTexto(s.factura_estado) }}</span>
                <span v-else class="estado-chip chip--gris">sin facturar</span>
              </td>
              <td>
                <div class="acciones-fila">
                  <button class="btn-icono btn-icono--accion" title="Generar factura del plan" :disabled="ocupado === s.suscripcion_id" @click="facturar(s)">
                    <i class="bi" :class="ocupado === s.suscripcion_id ? 'bi-arrow-clockwise spin' : 'bi-receipt'"></i>
                  </button>
                  <button class="btn-icono" title="Firmar y enviar al SRI" :disabled="!s.factura_id || ocupado === s.suscripcion_id" @click="firmar(s)"><i class="bi bi-pen"></i></button>
                  <button class="btn-icono" title="Descargar PDF" :disabled="!s.factura_id" @click="verPdf(s.factura_id)"><i class="bi bi-file-earmark-pdf"></i></button>
                  <button class="btn-icono btn-icono--peligro" title="Anular factura" :disabled="!s.factura_id || ocupado === s.suscripcion_id" @click="anular(s)"><i class="bi bi-x-circle"></i></button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ════════════ TAB FACTURAS EMITIDAS ════════════ -->
    <div v-show="tab === 'facturas'">
      <div class="filtros-fila">
        <button class="btn btn--secundario btn--xs" :disabled="cargandoFacturas" @click="cargarFacturas">
          <i class="bi" :class="cargandoFacturas ? 'bi-arrow-clockwise spin' : 'bi-arrow-clockwise'"></i> Refrescar
        </button>
      </div>
      <div class="tabla-contenedor">
        <div v-if="cargandoFacturas" class="texto-vacio"><i class="bi bi-arrow-clockwise spin"></i> Cargando...</div>
        <table v-else class="tabla">
          <thead>
            <tr>
              <th>Numero</th><th>Fecha</th><th>Cliente</th>
              <th class="text-end">Subtotal</th><th class="text-end">IVA</th><th class="text-end">Total</th>
              <th>Estado SRI</th><th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!facturas.length"><td colspan="8" class="texto-vacio">No hay facturas emitidas</td></tr>
            <tr v-for="f in facturas" :key="f.id">
              <td>{{ f.numero_factura }}</td>
              <td>{{ fmtDate(f.fecha_emision) }}</td>
              <td>
                <div class="tabla__empresa">{{ f.cliente_nombre }}</div>
                <div class="tabla__ruc">{{ f.cliente_identificacion }}</div>
              </td>
              <td class="text-end">${{ money(f.subtotal) }}</td>
              <td class="text-end">${{ money(f.iva) }}</td>
              <td class="text-end tabla__monto">${{ money(f.total) }}</td>
              <td><span class="estado-chip" :class="facturaCss(f.estado)">{{ f.estado_texto || facturaTexto(f.estado) }}</span></td>
              <td>
                <div class="acciones-fila">
                  <button class="btn-icono" title="Firmar y enviar al SRI" @click="firmarFactura(f.id)"><i class="bi bi-pen"></i></button>
                  <button class="btn-icono" title="Descargar PDF" @click="verPdf(f.id)"><i class="bi bi-file-earmark-pdf"></i></button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ════════════ TAB EMISOR ════════════ -->
    <div v-show="tab === 'emisor'" class="emisor">
      <div v-if="cargandoEmisor" class="texto-vacio"><i class="bi bi-arrow-clockwise spin"></i> Cargando...</div>
      <template v-else>
        <!-- Datos + logo -->
        <section class="tarjeta">
          <h3 class="tarjeta__titulo"><i class="bi bi-building"></i> Datos del emisor</h3>
          <div class="emisor-grid">
            <div class="emisor-datos">
              <div class="dato"><span>RUC</span><strong>{{ emisor.sri?.ruc_emisor || '-' }}</strong></div>
              <div class="dato"><span>Razon social</span><strong>{{ emisor.sri?.razon_social || '-' }}</strong></div>
              <div class="dato"><span>Nombre comercial</span><strong>{{ emisor.sri?.nombre_comercial || '-' }}</strong></div>
              <div class="dato"><span>Direccion matriz</span><strong>{{ emisor.sri?.direccion_matriz || '-' }}</strong></div>
              <div class="dato"><span>Obligado contabilidad</span><strong>{{ emisor.sri?.obligado_llevar_contabilidad || '-' }}</strong></div>
              <div class="dato">
                <span>Ambiente SRI</span>
                <div class="ambiente-control">
                  <span class="estado-chip" :class="Number(ambiente) === 2 ? 'chip--verde' : 'chip--amarillo'">
                    {{ Number(ambiente) === 2 ? 'Produccion' : 'Pruebas' }}
                  </span>
                  <select v-model.number="ambiente" class="campo-select campo-select--mini" style="max-width:160px">
                    <option :value="1">Pruebas</option>
                    <option :value="2">Produccion</option>
                  </select>
                  <button class="btn btn--primario btn--xs" :disabled="guardandoAmbiente || Number(ambiente) === Number(emisor.sri?.tipo_de_ambiente)" @click="guardarAmbiente">
                    <i class="bi" :class="guardandoAmbiente ? 'bi-arrow-clockwise spin' : 'bi-check-lg'"></i> Aplicar
                  </button>
                </div>
                <small class="nota" :class="{ 'texto-naranja': Number(ambiente) !== 2 }">
                  {{ Number(ambiente) === 2 ? 'Las facturas se enviaran al SRI de PRODUCCION (validas legalmente).' : 'Modo PRUEBAS: las facturas se envian al ambiente de certificacion del SRI.' }}
                </small>
              </div>
              <p class="nota">Los demas datos fiscales se editan en el portal del emisor. Aqui puedes cambiar ambiente, logo, firma y secuenciales.</p>
            </div>
            <div class="emisor-logo">
              <div class="logo-preview">
                <img v-if="logoSrc" :src="logoSrc" alt="logo" />
                <span v-else class="logo-vacio">Sin logo</span>
              </div>
              <label class="btn btn--secundario btn--xs">
                <i class="bi bi-upload"></i> Cambiar logo
                <input type="file" accept="image/png,image/jpeg,image/webp" hidden @change="onLogo" />
              </label>
              <span v-if="subiendoLogo" class="nota"><i class="bi bi-arrow-clockwise spin"></i> Subiendo...</span>
            </div>
          </div>
        </section>

        <!-- Firma electronica -->
        <section class="tarjeta">
          <h3 class="tarjeta__titulo"><i class="bi bi-shield-lock"></i> Firma electronica</h3>
          <div v-if="firma" class="firma-estado">
            <div class="dato"><span>Certificado</span><strong>{{ firma.certificado_nombre || '-' }}</strong></div>
            <div class="dato"><span>Entidad</span><strong>{{ firma.entidad_emisora || '-' }}</strong></div>
            <div class="dato"><span>Emision</span><strong>{{ fmtDate(firma.fecha_emision) }}</strong></div>
            <div class="dato">
              <span>Vencimiento</span>
              <strong :class="firmaVenceCss">{{ fmtDate(firma.fecha_vencimiento) }} <small>{{ firmaVenceTexto }}</small></strong>
            </div>
          </div>
          <p v-else class="nota">No hay firma electronica cargada. Suba el archivo .p12 para poder firmar facturas.</p>

          <div class="firma-form">
            <label class="btn btn--secundario btn--xs">
              <i class="bi bi-paperclip"></i> {{ firmaArchivo ? firmaArchivo.name : 'Seleccionar .p12' }}
              <input type="file" accept=".p12,.pfx" hidden @change="onFirmaArchivo" />
            </label>
            <input v-model="firmaPassword" type="password" class="campo-busqueda" placeholder="Contrasena del certificado" style="max-width:240px" />
            <button class="btn btn--primario btn--xs" :disabled="!firmaArchivo || !firmaPassword || subiendoFirma" @click="subirFirma">
              <i class="bi" :class="subiendoFirma ? 'bi-arrow-clockwise spin' : 'bi-cloud-upload'"></i>
              {{ firma ? 'Renovar firma' : 'Subir firma' }}
            </button>
          </div>
        </section>

        <!-- Secuenciales -->
        <section class="tarjeta">
          <h3 class="tarjeta__titulo"><i class="bi bi-123"></i> Secuenciales de factura</h3>
          <p v-if="!secuenciales.length" class="nota">No hay secuenciales configurados.</p>
          <table v-else class="tabla">
            <thead><tr><th>Establecimiento</th><th>Punto</th><th>Documento</th><th>Proximo secuencial</th><th></th></tr></thead>
            <tbody>
              <template v-for="g in secuenciales" :key="g.eep_id">
                <tr v-for="seq in g.sequences" :key="g.eep_id + '-' + seq.document_type">
                  <td>{{ g.establishment_code }}</td>
                  <td>{{ g.emission_point_code }}</td>
                  <td>{{ seq.document_type }}</td>
                  <td><input v-model.number="seq.current" type="number" min="1" class="campo-busqueda" style="max-width:160px" /></td>
                  <td>
                    <button class="btn-icono btn-icono--accion" title="Guardar secuencial" @click="guardarSecuencial(g, seq)"><i class="bi bi-check-lg"></i></button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </section>
      </template>
    </div>
  </div>
</template>

<script>
import fp from '@/services/facturacionPlanesService'
import { notifySuccess, notifyError } from '@/services/notificationService'

export default {
  name: 'FacturacionPlanes',
  data() {
    return {
      tab: 'planes',
      error: null,
      // planes
      cargando: false, suscripciones: [], ciclos: {}, ocupado: null,
      loteEnCurso: false, loteResumen: null,
      filtros: { busqueda: '', estado: '', facturacion: '' },
      // facturas
      cargandoFacturas: false, facturas: [],
      // emisor
      cargandoEmisor: false, emisor: { sri: null, logo: null },
      ambiente: 1, guardandoAmbiente: false,
      firma: null, firmaArchivo: null, firmaPassword: '', subiendoFirma: false,
      subiendoLogo: false, secuenciales: [],
    }
  },
  computed: {
    filtradas() {
      const b = this.filtros.busqueda.toLowerCase()
      return this.suscripciones.filter(s => {
        const matchB = !b || (s.empresa_ruc || '').includes(b) || (s.empresa_razon_social || '').toLowerCase().includes(b)
        const matchE = !this.filtros.estado || s.suscripcion_estado === this.filtros.estado
        const matchF = !this.filtros.facturacion || (this.filtros.facturacion === 'facturada' ? !!s.factura_id : !s.factura_id)
        return matchB && matchE && matchF
      })
    },
    logoSrc() {
      return this.emisor.logo?.logo_ruta ? fp.logoUrl(this.emisor.logo.logo_ruta) : null
    },
    firmaVenceDias() {
      if (!this.firma?.fecha_vencimiento) return null
      const v = new Date(this.firma.fecha_vencimiento)
      return Math.ceil((v - new Date()) / 86400000)
    },
    firmaVenceCss() {
      const d = this.firmaVenceDias
      if (d == null) return ''
      if (d < 0) return 'texto-rojo'
      if (d <= 30) return 'texto-naranja'
      return 'texto-verde'
    },
    firmaVenceTexto() {
      const d = this.firmaVenceDias
      if (d == null) return ''
      return d < 0 ? '(vencida)' : `(${d}d)`
    },
  },
  mounted() { this.cargar() },
  methods: {
    // ── planes ──
    async cargar() {
      this.cargando = true; this.error = null
      try {
        this.suscripciones = await fp.listar()
        for (const s of this.suscripciones) {
          if (!this.ciclos[s.suscripcion_id]) this.ciclos[s.suscripcion_id] = s.plan_periodo || 'mensual'
        }
      } catch (e) {
        this.error = 'No se pudieron cargar las suscripciones: ' + (e.response?.data?.error || e.message)
      } finally { this.cargando = false }
    },
    montoCiclo(s) {
      const c = this.ciclos[s.suscripcion_id] || s.plan_periodo || 'mensual'
      return Number(s['precio_' + c] || 0)
    },
    async facturar(s) {
      if (s.factura_id && !window.confirm('Ya existe una factura para este periodo. Generar otra?')) return
      this.ocupado = s.suscripcion_id
      try {
        const c = this.ciclos[s.suscripcion_id] || s.plan_periodo || 'mensual'
        const res = await fp.facturar(s.suscripcion_id, c)
        notifySuccess(`Factura generada: ${res.numero_factura || res.factura_id}.`)
        await this.cargar()
      } catch (e) { notifyError(e.response?.data?.error || 'No se pudo generar la factura.') }
      finally { this.ocupado = null }
    },
    async facturarTodos() {
      if (!window.confirm('Generar la factura de todas las suscripciones vigentes pendientes?')) return
      this.loteEnCurso = true; this.loteResumen = null
      try {
        const res = await fp.facturarTodos()
        this.loteResumen = res.mensaje + (res.errores?.length ? ` (${res.errores.length} con error)` : '')
        notifySuccess(res.mensaje)
        await this.cargar()
      } catch (e) { notifyError(e.response?.data?.error || 'Error al generar el lote.') }
      finally { this.loteEnCurso = false }
    },
    async firmar(s) {
      this.ocupado = s.suscripcion_id
      try { await fp.firmar(s.factura_id); notifySuccess('Factura enviada al SRI.'); await this.cargar() }
      catch (e) { notifyError(e.response?.data?.error || e.response?.data?.message || 'No se pudo firmar.') }
      finally { this.ocupado = null }
    },
    async anular(s) {
      if (!window.confirm('Confirma anular la factura del plan?')) return
      this.ocupado = s.suscripcion_id
      try { await fp.anular(s.factura_id, 'Anulacion factura de plan'); notifySuccess('Factura anulada.'); await this.cargar() }
      catch (e) { notifyError(e.response?.data?.error || 'No se pudo anular.') }
      finally { this.ocupado = null }
    },
    verPdf(id) { window.open(fp.pdfUrl(id), '_blank', 'noopener') },
    // ── facturas emitidas ──
    irFacturas() { this.tab = 'facturas'; if (!this.facturas.length) this.cargarFacturas() },
    async cargarFacturas() {
      this.cargandoFacturas = true; this.error = null
      try { this.facturas = await fp.listarFacturas() }
      catch (e) { this.error = 'No se pudieron cargar las facturas: ' + (e.response?.data?.error || e.message) }
      finally { this.cargandoFacturas = false }
    },
    async firmarFactura(id) {
      try { await fp.firmar(id); notifySuccess('Factura enviada al SRI.'); await this.cargarFacturas() }
      catch (e) { notifyError(e.response?.data?.error || e.response?.data?.message || 'No se pudo firmar.') }
    },
    // ── emisor ──
    irEmisor() { this.tab = 'emisor'; if (!this.emisor.sri) this.cargarEmisor() },
    async cargarEmisor() {
      this.cargandoEmisor = true; this.error = null
      try {
        const cfg = await fp.obtenerConfigEmisor()
        this.emisor = { sri: cfg?.configuracion_sri || null, logo: cfg?.logo || null }
        this.ambiente = Number(cfg?.configuracion_sri?.tipo_de_ambiente) === 2 ? 2 : 1
        this.firma = await fp.obtenerFirma()
        this.secuenciales = await fp.obtenerSecuenciales()
      } catch (e) {
        this.error = 'No se pudo cargar la configuracion del emisor: ' + (e.response?.data?.error || e.message)
      } finally { this.cargandoEmisor = false }
    },
    async guardarAmbiente() {
      this.guardandoAmbiente = true
      try {
        const res = await fp.guardarAmbiente(Number(this.ambiente))
        if (this.emisor.sri) this.emisor.sri.tipo_de_ambiente = Number(this.ambiente)
        notifySuccess(res.message || 'Ambiente actualizado.')
      } catch (e) { notifyError(e.response?.data?.error || 'No se pudo cambiar el ambiente.') }
      finally { this.guardandoAmbiente = false }
    },
    async onLogo(ev) {
      const file = ev.target.files?.[0]; if (!file) return
      this.subiendoLogo = true
      try {
        const res = await fp.subirLogo(file)
        this.emisor.logo = { logo_ruta: res.logo_ruta }
        notifySuccess('Logo actualizado.')
      } catch (e) { notifyError(e.response?.data?.error || 'No se pudo subir el logo.') }
      finally { this.subiendoLogo = false; ev.target.value = '' }
    },
    onFirmaArchivo(ev) { this.firmaArchivo = ev.target.files?.[0] || null },
    async subirFirma() {
      this.subiendoFirma = true
      try {
        await fp.guardarFirma(this.firmaArchivo, this.firmaPassword)
        notifySuccess('Firma electronica guardada.')
        this.firmaArchivo = null; this.firmaPassword = ''
        this.firma = await fp.obtenerFirma()
      } catch (e) { notifyError(e.response?.data?.error || 'No se pudo guardar la firma.') }
      finally { this.subiendoFirma = false }
    },
    async guardarSecuencial(g, seq) {
      try {
        await fp.guardarSecuencial(g.eep_id, seq.document_type, Number(seq.current))
        notifySuccess('Secuencial actualizado.')
      } catch (e) { notifyError(e.response?.data?.error || 'No se pudo actualizar el secuencial.') }
    },
    // ── helpers ──
    money(v) { return Number(v || 0).toFixed(2) },
    fmtDate(s) {
      if (!s) return '-'
      const p = String(s).slice(0, 10).split('-')
      return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : s
    },
    estadoCss(e) { return ({ activa: 'chip--verde', en_gracia: 'chip--amarillo', vencida: 'chip--rojo', cancelada: 'chip--gris' })[e] || 'chip--gris' },
    facturaCss(e) {
      const n = Number(e)
      if (n === 5) return 'chip--verde'
      if (n === 8 || n === 6 || n === 7) return 'chip--rojo'
      return 'chip--azul'
    },
    facturaTexto(e) { return ({ 2: 'generada', 3: 'firmada', 4: 'enviada', 5: 'autorizada', 6: 'rechazada', 7: 'error', 8: 'anulada' })[Number(e)] || 'generada' },
    venceCss(d) {
      if (d == null) return ''
      if (d <= 3) return 'texto-rojo'
      if (d <= 7) return 'texto-naranja'
      if (d <= 15) return 'texto-amarillo'
      return ''
    },
  },
}
</script>

<style scoped>
.fp { padding:1.5rem; max-width:1400px; margin:0 auto; display:flex; flex-direction:column; gap:1.25rem; color:var(--text-primary); }
.fp-cabecera { display:flex; align-items:flex-start; justify-content:space-between; gap:1rem; }
.fp-titulo { font-size:1.5rem; font-weight:700; margin:0 0 .25rem; }
.fp-subtitulo { font-size:.875rem; color:var(--text-secondary); margin:0; }
.fp-tabs { display:flex; gap:.25rem; border-bottom:1px solid var(--border-main); }
.fp-tab { background:none; border:none; border-bottom:2px solid transparent; padding:.6rem 1rem; cursor:pointer; color:var(--text-secondary); font-size:.875rem; font-weight:600; display:inline-flex; gap:.4rem; align-items:center; }
.fp-tab--activo { color:var(--primary-main); border-bottom-color:var(--primary-main); }
.alerta { padding:.75rem 1rem; border-radius:.5rem; display:flex; gap:.5rem; }
.alerta-error { background:color-mix(in srgb,var(--accent-danger) 10%,transparent); color:var(--accent-danger); border:1px solid color-mix(in srgb,var(--accent-danger) 30%,transparent); }
.alerta-info { background:color-mix(in srgb,#0ea5e9 10%,transparent); color:#0ea5e9; border:1px solid color-mix(in srgb,#0ea5e9 30%,transparent); }
.filtros-fila { display:flex; gap:.75rem; flex-wrap:wrap; align-items:center; }
.campo-busqueda,.campo-select { background:var(--bg-main); border:1px solid var(--border-main); border-radius:.375rem; padding:.5rem .75rem; color:var(--text-primary); font-size:.875rem; }
.campo-busqueda { flex:1; min-width:180px; }
.campo-select { min-width:170px; }
.campo-select--mini { min-width:0; width:100%; padding:.3rem .4rem; font-size:.78rem; }
.tabla-contenedor { background:var(--secondary-bg-main); border:1px solid var(--border-main); border-radius:.75rem; overflow:auto; }
.tabla { width:100%; border-collapse:collapse; font-size:.825rem; }
.tabla th { text-align:left; padding:.6rem .75rem; font-size:.75rem; font-weight:600; color:var(--text-secondary); border-bottom:1px solid var(--border-main); white-space:nowrap; }
.tabla td { padding:.6rem .75rem; border-bottom:1px solid var(--border-main); vertical-align:middle; }
.tabla tr:last-child td { border-bottom:none; }
.tabla__empresa { font-weight:600; }
.tabla__ruc { font-size:.7rem; color:var(--text-muted); }
.tabla__monto { font-weight:700; color:var(--accent-success); }
.text-end { text-align:right; }
.plan-badge { font-size:.72rem; font-weight:700; color:#fff; padding:.2rem .5rem; border-radius:.25rem; background:var(--primary-main); white-space:nowrap; }
.estado-chip { font-size:.72rem; font-weight:600; padding:.15rem .5rem; border-radius:999px; text-transform:capitalize; }
.chip--verde { background:color-mix(in srgb,var(--accent-success) 15%,transparent); color:var(--accent-success); }
.chip--rojo { background:color-mix(in srgb,var(--accent-danger) 15%,transparent); color:var(--accent-danger); }
.chip--amarillo { background:color-mix(in srgb,var(--accent-warning) 15%,transparent); color:var(--accent-warning); }
.chip--gris { background:color-mix(in srgb,var(--text-muted) 15%,transparent); color:var(--text-muted); }
.chip--azul { background:color-mix(in srgb,#0ea5e9 15%,transparent); color:#0ea5e9; }
.texto-rojo { color:var(--accent-danger); font-weight:600; }
.texto-naranja { color:#f97316; font-weight:600; }
.texto-amarillo { color:var(--accent-warning); font-weight:600; }
.texto-verde { color:var(--accent-success); font-weight:600; }
.texto-vacio { text-align:center; color:var(--text-muted); padding:2rem; font-size:.875rem; }
.acciones-fila { display:flex; gap:.25rem; }
.btn { display:inline-flex; align-items:center; gap:.4rem; border:none; border-radius:.5rem; padding:.6rem 1.2rem; cursor:pointer; font-size:.875rem; font-weight:600; }
.btn:disabled { opacity:.5; cursor:not-allowed; }
.btn--primario { background:var(--primary-main); color:#fff; }
.btn--secundario { background:var(--bg-main); color:var(--text-primary); border:1px solid var(--border-main); }
.btn--xs { padding:.35rem .75rem; font-size:.8rem; }
.btn-icono { background:none; border:1px solid var(--border-main); border-radius:.375rem; padding:.3rem .5rem; cursor:pointer; color:var(--text-secondary); }
.btn-icono:hover:not(:disabled) { background:var(--bg-main); color:var(--text-primary); }
.btn-icono:disabled { opacity:.4; cursor:not-allowed; }
.btn-icono--accion { color:var(--primary-main); border-color:color-mix(in srgb,var(--primary-main) 40%,transparent); }
.btn-icono--peligro { color:var(--accent-danger); border-color:color-mix(in srgb,var(--accent-danger) 40%,transparent); }
.spin { animation:rotar 1s linear infinite; display:inline-block; }
@keyframes rotar { to { transform:rotate(360deg); } }
/* emisor */
.emisor { display:flex; flex-direction:column; gap:1rem; }
.tarjeta { background:var(--secondary-bg-main); border:1px solid var(--border-main); border-radius:.75rem; padding:1.1rem 1.25rem; }
.tarjeta__titulo { font-size:1rem; font-weight:700; margin:0 0 .9rem; display:flex; gap:.5rem; align-items:center; }
.emisor-grid { display:grid; grid-template-columns:1fr 220px; gap:1.5rem; }
.emisor-datos { display:flex; flex-direction:column; gap:.5rem; }
.dato { display:flex; flex-direction:column; gap:.1rem; }
.dato span { font-size:.72rem; color:var(--text-muted); }
.ambiente-control { display:flex; gap:.5rem; align-items:center; flex-wrap:wrap; margin-top:.2rem; }
.dato strong { font-size:.9rem; }
.nota { font-size:.78rem; color:var(--text-secondary); margin:.5rem 0 0; }
.emisor-logo { display:flex; flex-direction:column; gap:.6rem; align-items:center; }
.logo-preview { width:200px; height:120px; border:1px dashed var(--border-main); border-radius:.5rem; display:flex; align-items:center; justify-content:center; overflow:hidden; background:var(--bg-main); }
.logo-preview img { max-width:100%; max-height:100%; object-fit:contain; }
.logo-vacio { color:var(--text-muted); font-size:.8rem; }
.firma-estado { display:grid; grid-template-columns:repeat(auto-fit,minmax(160px,1fr)); gap:.75rem; margin-bottom:1rem; }
.firma-form { display:flex; gap:.6rem; flex-wrap:wrap; align-items:center; }
@media (max-width:768px) { .filtros-fila { flex-direction:column; align-items:stretch; } .emisor-grid { grid-template-columns:1fr; } }
</style>
